import React from 'react';
import { observer } from 'mobx-react-lite';
import { Modal, Button, TextArea } from '@insurancemenu/imenu-components-lib';
import FormsSpinner from 'components/common/loaders/FormSpinner';
import { useRootStore } from 'store/rootStore';
import { createStyles } from './styles';

interface EditNotesModalProps {
  show: boolean;
  employerGroupId?: string;
  onClose: () => void;
}

const EditNotesModal: React.FC<EditNotesModalProps> = observer(({ show, employerGroupId, onClose }) => {
  // Mobx store
  const rootStore = useRootStore();
  const { groupNotesModalStore } = rootStore;

  // Component actions
  async function onSubmit(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    await groupNotesModalStore.saveGroupNotes(employerGroupId || '');
    onClose();
  }

  const classes = createStyles();
  return (
    <Modal show={show} onClose={onClose} className={classes.modalSpacing} closable={false} id="notes">
      <form onSubmit={onSubmit} className={classes.form} id="notes-form">
        <div className={classes.body}>
          <span className={classes.textAreaName}>Notes:</span>
          <TextArea
            name="notes"
            value={groupNotesModalStore.notesForm.fields.notes.value}
            onChange={groupNotesModalStore.notesForm.onFieldChange}
            width="100%"
            height="48rem"
            maxLength={10000}
          />
        </div>
        <footer className={classes.footer}>
          <Button color="primary" htmlType="submit" size="large" id="save-notes-button">
            Save
          </Button>
        </footer>
        <FormsSpinner display={groupNotesModalStore.loading} />
      </form>
    </Modal>
  );
});

export default EditNotesModal;
